import { render, staticRenderFns } from "./virtualConversations.vue?vue&type=template&id=537ed8aa&scoped=true"
import script from "./virtualConversations.vue?vue&type=script&lang=js"
export * from "./virtualConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ed8aa",
  null
  
)

export default component.exports